module.exports = __webpack_public_path__ + "img/logo.a684c2ea.png";